import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from 'components/App';
import reportWebVitals from 'reportWebVitals';
import 'assets/sass/index.scss';
import 'common/i18n';
import * as Sentry from '@sentry/react';
import { BrowserRouter } from 'react-router-dom';
import { getRouterBasename } from 'common/helpers/router.helper';

Sentry.init({
  dsn: 'https://c6c87d5bcbb2ddb8f7f0ed629e483885@o4506466959884288.ingest.us.sentry.io/4507294248468480',
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <BrowserRouter basename={getRouterBasename(window.location.pathname)}>
    <App />
  </BrowserRouter>,
);

reportWebVitals();
